<template lang="pug">
    div.version-update
        el-dialog(
            title="重要更新说明"
            :visible.sync="updateData.show"
            :close-on-click-modal="false"
            :show-close="false"
            width="558px"
            center
        )
            div.box
                div.box-header
                    section {{ updateData.data.title }}
                    section v{{ updateData.data.versionNumber }} 发布时间：{{ updateData.data.releaseTime | dateFormat('YYYY/MM/DD HH:mm') }}
                div.box-content
                    pre.pre-style {{ updateData.data.description }}
            div.btn
                el-button(
                    @click="hadRead"
                    type="primary"
                ) 知道了
</template>
<script>
import { versionApis } from '@/api';

export default {
    name: 'VersionUpdate',
    props: {
        updateData: {
            type: Object,
            default: () => ({
                show: false,
                data: {},
            }),
        },
    },
    methods: {
        async hadRead() {
            try {
                await versionApis.markRead({
                    versionNumber: this.updateData.data.versionNumber,
                });
            } catch (err) {
                throw new Error(err);
            } finally {
                this.updateData.show = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
    .version-update {
        .box {
            padding: 20px 20px 0;
            margin-bottom: 72px;
            &-header {
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                section:first-child {
                    font-size: 14px;
                    color: #333333;
                    font-weight: 600;
                }
                section:last-child {
                    font-size: 12px;
                    color: #999999;
                }
            }
            &-content {
                font-size: 13px;
                color: #4E4E4E;
                line-height: 20px;
                max-height: 220px;
                overflow-y: scroll;
                .pre-style {
                    white-space: pre-wrap;
                    word-wrap: break-word;
                }
            }
        }
        .btn {
            width: 100%;
            height: 72px;
            background: #fff;
            position: absolute;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
<style lang="scss">
    .version-update {
        .el-dialog__body {
            padding: 0 !important;
        }
        .el-button {
            border-radius: 16px;
            height: 32px;
            width: 200px;
        }
    }
</style>
